/**
 * Favicon e manifest depois da primeira pintura útil (SPEC 10.4, 10.5). O build tira os
 * `<link rel="icon">` e o `<link rel="manifest">` do `<head>` e os guarda num
 * `<template id="rota-late-head">` (vite.config, `deferHeadLinks`), para não ocuparem conexões
 * junto com o JS e o CSS da primeira tela; no lugar fica um ícone `data:` vazio, que impede o
 * Chrome de pedir /favicon.ico. Aqui os links voltam ao `<head>`, uma vez só, e o ícone vazio sai.
 * Sem o template (dev, testes), não faz nada: os links já estão no HTML.
 */
import { whenPainted } from './afterPaint';

export const LATE_HEAD_ID = 'rota-late-head';

/** Põe no `<head>` os links guardados no template e tira o ícone provisório. Idempotente. */
export function attachLateHead(doc: Document = document): void {
  const tpl = doc.getElementById(LATE_HEAD_ID);
  if (!(tpl instanceof HTMLTemplateElement)) return;
  tpl.remove();
  for (const el of doc.head.querySelectorAll('link[rel="icon"][href^="data:"]')) el.remove();
  doc.head.appendChild(tpl.content.cloneNode(true));
}

/** Agenda `attachLateHead` para depois da primeira pintura útil (ou do tempo-limite do `whenPainted`). */
export function attachLateHeadAfterPaint(doc: Document = document): void {
  if (!doc.getElementById(LATE_HEAD_ID)) return;
  whenPainted(() => attachLateHead(doc));
}
